import { createSlice } from '@reduxjs/toolkit'
import { fetchCampaigns } from './campaignThunks';

function initializeCampaignState() {
  let initialState = {
    campaigns: null,
    loading: false,
  }
  return initialState;
}

export const campaignSlice = createSlice({
  name: 'campaign',
  initialState: initializeCampaignState(),
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaigns.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        state.loading = false;
        state.campaigns = action.payload
      })
      .addCase(fetchCampaigns.rejected, (state) => {
        state.loading = false;
        state.campaigns = [];
      })
  },
})

// Action creators are generated for each case reducer function
export const {
} = campaignSlice.actions

export default campaignSlice.reducer